import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { TextField, Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const InputSearch = ({
    disabled,
    onChange,
    placeholder,
    value,
    visible = true,
}) => {
    const handleOnChange = (e) => onChange(e);
    if (!visible) return null;
    return (
        <TextField
            disabled={disabled}
            fullWidth
            label={
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <SearchIcon />
                    {placeholder}
                </Box>
            }
            onChange={handleOnChange}
            value={value}
            variant="outlined"
        />
    );
};

InputSearch.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    visible: PropTypes.bool,
};

export default InputSearch;
